import React, { Component } from 'react';
import { Redirect,Link } from 'react-router-dom';
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Button,
  Table
} from 'reactstrap';
import { GetData } from '../../services/GetData';
import moment from 'moment';
import $ from 'jquery';

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stud: [],
      emp: [],
      empbday: [],
      studbday: [],
      leave: [],
      eve: [],
      dropdownOpen: false,
      radioSelected: 2,
      _redirect: false
    }
    this.toggle = this.toggle.bind(this);
    this.onRadioBtnClick = this.onRadioBtnClick.bind(this);
    this.onBack = this.onBack.bind(this);
  }

  onBack(e) {

    this.setState({ _redirect: true });
  }

  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }

  onRadioBtnClick(radioSelected) {
    this.setState({
      radioSelected: radioSelected
    });
  }

  /** this function will be call when page loading **/
  componentWillMount() {

    this.getstd();
    this.getemployee();
    this.getempbday();
    this.getstudbday();
    this.getevents();
    this.getleave();
  }

  /** get Students **/
  getevents() {
    $("#showLoader").show();
    GetData('event/getcomingevents').then((result) => {
      $("#showLoader").hide();
      let responseJson = result;
      if (responseJson) {
        this.setState({
          eve: responseJson
        });
      }
    });
  }

  /** get Students **/
  getstd() {
    $("#showLoader").show();
    GetData('student/getstudcount').then((result) => {
      $("#showLoader").hide();
      let responseJson = result;
      if (responseJson) {
        this.setState({
          stdcount: responseJson
        });
      }
    });
  }

  getemployee() {

    GetData('employee/getemployeecount').then((result) => {
      let responseJson = result;
      if (responseJson) {
        this.setState({
          empcount: responseJson
        });
      }
    });
  }

  getempbday() {

    GetData('employee/getbdaycount').then((result) => {
      let responseJson = result;
      if (responseJson) {
        this.setState({
          empbday: responseJson
        });
        this.setState({ empbdaycount: this.state.empbday.length });
      }
    });
  }

  getstudbday() {
    $("#showLoader").show();
    GetData('student/getstudbdaycount').then((result) => {
      $("#showLoader").hide();
      let responseJson = result;
      if (responseJson) {
        this.setState({
          studbday: responseJson
        });
        this.setState({ studbdaycount: this.state.studbday.length });
      }
    });
  }
  
  getleave(){
		this.setState({loading:true});
		$("#showLoader").show();
		GetData('leave/mobleavereqsbydate').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					leave : responseJson,
					loading:false
				});
			}
		});
	}

  checkedate(dat) {

    var ed = new Date(dat);
    var momentObj = moment(ed);
    var momentString = momentObj.format('MMMM DD , Y');
    return momentString;
  }

  render() {

    if (this.state._redirect) {

      return (<Redirect to={'/events/event'} />);
    }

    return (
      <div className="animated fadeIn" style={{ marginTop: '10px' }}>
        <Row>
          <Col xs="12" sm="6" lg="3">
            <Card className="text-white" id="stdcount">
              <CardBody className="pb-0">
                <div className="float-right">
                  <i id="headicon" className="icon-graduation" ></i>
                </div>
                <h4 className="mb-0"><span>{this.state.stdcount}</span></h4>
                <p>Total Students</p>
              </CardBody>
            </Card>
          </Col>

          <Col xs="12" sm="6" lg="3">
            <Card className="text-white" id="empcount">
              <CardBody className="pb-0">
                <div className="float-right">
                  <i id="headicon" className="icon-user" ></i>
                </div>
                <h4 className="mb-0"><span>{this.state.empcount}</span></h4>
                <p>Total Employees</p>
              </CardBody>
            </Card>
          </Col>

          <Col xs="12" sm="6" lg="3">
            <Card className="text-white" id="feecount">
              <CardBody className="pb-0">
                <div className="float-right">
                  <i id="headicon" className="icon-notebook" ></i>
                </div>
                <h4 className="mb-0">14</h4>
                <p>Total Classes</p>
              </CardBody>
            </Card>
          </Col>

          <Col xs="12" sm="6" lg="3">
            <Card className="text-white" id="lastfeecount">
              <CardBody className="pb-0">
                <div className="float-right">
                  <i id="headicon" className="icon-list" ></i>
                </div>
                <h4 className="mb-0">6</h4>
                <p>Total Section</p>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col md="6">
            <Card>
              <CardHeader>
                <strong>Upcoming Events</strong>
                <Button outline color="primary" className="btn-right" onClick={this.onBack}>View All</Button>
              </CardHeader>
              <CardBody>
                <Table responsive bordered>
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Event Type</th>
                      <th>Event Title</th>
                      <th>Event Date</th>
                      <th>Event Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.eve.length > 0 ?
                      this.state.eve.map((item, i) =>
                        <tr key={item}>
                          <td>{i + 1}</td>
                          <td>{item.evetype}</td>
                          <td>{item.eventname}</td>
                          <td>{this.checkedate(item.eventdate)}</td>
                          <td>{item.eventtime}</td>
                        </tr>
                      ) :
                      <tr>
                        <td colSpan="5" align="center"><b style={{ color: 'red' }}>No Events....</b></td>
                      </tr>}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
		  <Col md="6">
            <Card>
              <CardHeader>
                <strong>Leave Request</strong>
				<Link to="/student/leaverequests" className="btn btn-outline-info btn-right" >View All</Link>
              </CardHeader>
              <CardBody>
                <Table responsive bordered>
                  <thead>
                    <tr>
                      <th>Reg.No</th>
                      <th>Name</th>
                      <th>Date</th>
                      <th>Reason</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.leave.length > 0 ?
                      this.state.leave.map((item, i) =>
                        <tr key={item}>
                          <td>{item.regno}</td>
                          <td>{item.stname}<br />{item.classname}-{item.secname}</td>
                          <td>{item.fromdate} {item.fromdate==item.todate ? '' : 'to '+item.todate}</td>
                          <td>{item.reason}</td>
                          <td>{item.isapproved === '1' ? 'Approved' : 'Pending'}</td>
                        </tr>
                      ) :
                      <tr>
                        <td colSpan="5" align="center"><b style={{ color: 'red' }}>No Request Found....</b></td>
                      </tr>}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col md="8">
            <Card>
              <CardHeader>
                <strong>Today Birthday Students</strong>
              </CardHeader>
              <CardBody>
                <Table responsive bordered>
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Name</th>
                      <th>Class</th>
                      <th>Section</th>
                      <th>DOB</th>
                      <th>Mobile</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.studbday.length > 0 ?
                      this.state.studbday.map((item, i) =>

                        <tr key={item}>
                          <td>{i + 1}</td>
                          <td>{item.stdname}</td>
                          <td>{item.classname}</td>
                          <td>{item.secname}</td>
                          <td>{this.checkedate(item.dob)}</td>
                          <td>{item.mobile}</td>
                        </tr>
                      ) :
                      <tr>
                        <td colSpan="6" align="center"><b style={{ color: 'red' }}>Data Not Found....</b></td>
                      </tr>}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
          <Col md="4">
            <Card>
              <CardHeader>
                <strong>Birthday Today</strong>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col md="3">
                    <i className="fa fa-birthday-cake" id="bdayfont"></i>
                  </Col>
                  <Col md="9">
                    <b className="bdaycount">{this.state.studbdaycount}</b><br></br>
                    Students have birthday today
                </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col md="8">
            <Card>
              <CardHeader>
                <strong>Today Birthday Employees</strong>
              </CardHeader>
              <CardBody>
                <Table responsive bordered>
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Name</th>
                      <th>Department</th>
                      <th>DOB</th>
                      <th>Mobile</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.empbday.length > 0 ?
                      this.state.empbday.map((item, i) =>
                        <tr key={item}>
                          <td>{i + 1}</td>
                          <td>{item.empname}</td>
                          <td>{item.department}</td>
                          <td>{this.checkedate(item.dob)}</td>
                          <td>{item.mobile}</td>
                        </tr>
                      ) :
                      <tr>
                        <td colSpan="5" align="center"><b style={{ color: 'red' }}>Data Not Found....</b></td>
                      </tr>}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
          <Col md="4">
            <Card>
              <CardHeader>
                <strong>Birthday Today</strong>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col md="3">
                    <i className="fa fa-birthday-cake" id="bdayfont"></i>
                  </Col>
                  <Col md="9">
                    <b className="bdaycount">{this.state.empbdaycount}</b><br></br>
                    Employees have birthday today
                </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }
}

export default Dashboard;


// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.js